<companyid-title-with-social-media
    title="Privacy Policy"
    i18n-title="@@privacy-policy-title"
    i18n-subtitle="@@privacy-policy-subtitle"
    subtitle="This Privacy Policy describes Our policies and procedures on the collection, use and
        disclosure of Your information when You use the Service and tells You about Your privacy
        rights and how the law protects You.

        We use Your Personal data to provide and improve the Service. By using the Service, You
        agree to the collection and use of information in accordance with this Privacy Policy. This
        Privacy Policy has been created with the help of the">
    <a
        i18n="@@privacy-policy-link"
        href="https://www.privacypolicies.com/privacy-policy-generator/"
        target="_blank"
        class="underline">
        Privacy Policy Generator.</a
    >
</companyid-title-with-social-media>
<companyid-text-block-with-side-bar [contentItems]="privacyPolicyTexts" />
